<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    ref="almondco-inshell-allocation-list"
    :rowAlternationEnabled="false"
    :persistenceKey="'almondco-inshell-allocation-list'"
  >
    <template #popup>
      <GcPopupReserveLot
        :popupConfig="ReserveLotPopupConfig"
        :data-model="dataModel"
        :on-hide="onReserveLotPopupHide"
        v-if="ReserveLotPopupConfig.isPopupShow"
        :displayServerError="displayServerError"
        @onSaveReserveLot="ReserveLot"
      />

      <GcPopupOfferLot
        :popupConfig="OfferLotPopupConfig"
        :data-model="dataModel"
        :on-hide="onOfferLotPopupHide"
        v-if="OfferLotPopupConfig.isPopupShow"
        :displayServerError="displayServerError"
        @onSaveOfferLot="OfferLot"
      />

      <AlmondcoInshellLotAllocationHistoryPopup
        v-if="historyPopupVisible"
        :lot-no="selectedLotNo"
        :visible="historyPopupVisible"
        @hide="historyPopupVisible = false"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import FormMixin from "@/_mixins/form.mixin";
import RouteMixin from "@/_mixins/route.mixin";

import {
  GetIndexByTabName,
  InshellTabs,
} from "@/_models/tabdata/inventory/inshell";
import TransactionListTemplate from "@/templates/transaction-list";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { InshellService } from "@/_services/api/inventory/inshell.service";
import GcPopupReserveLot from "../../../popups/inventory/inshell/gc-popup-reserve-lot.vue";
import GcPopupOfferLot from "../../../popups/inventory/inshell/gc-popup-offer-lot.vue";
import AlmondcoInshellLotAllocationHistoryPopup from "../../../popups/inventory/inshell/almondco-inshell-lot-allocation-history-popup.vue";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
    GcPopupReserveLot,
    GcPopupOfferLot,
    AlmondcoInshellLotAllocationHistoryPopup,
  },
  data() {
    return {
      setLoading: false,
      ReserveLotPopupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 500,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
        dataModel: undefined,
      },

      OfferLotPopupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 500,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
      },
      dataModel: undefined,
      selectedLotNo: 0,
      historyPopupVisible: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Inshell",
        ScreenName: "Inshell - Allocation",
        selectedIndex: GetIndexByTabName("Allocation"),
        tabs: InshellTabs,
        exportFileName: "Allocation List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoInshellLotAllocation",
              // items: [],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.postProcessGridData,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No Allocations",
                message: "There are no allocations to display.",
              },
            },
            options: {
              onRowPreparedCallBack: this.onRowPreparedCallBack,
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            // multiplePdf: true,
            // screenName: "Sales Orders - Invoiced",
          },
          columns: [
            // Lot No
            {
              screenField: "LotNo",
              sortOrder: "desc",
              sortIndex: 1,
              filterIndex: 1,
              type: "Integer",
              filterDataField: "LotNo",
              width: 75,
              allowHiding: false,
              hyperlink: {
                url: `report/intake/grid/report-inshell-pallet-location`,
                target: "_blank",
                params: ["LotNo"],
              },
            },
            // Branch
            {
              screenField: "Branch",
              filterDataField: "BranchCode",
              gridDataField: "BranchCode",
              filterIndex: 9,
              allowHiding: false,
              // width: ColumnWidth.Branch.width,
              // minWidth: ColumnWidth.Branch.minWidth,
            },
            // Product
            {
              screenField: "AlmondcoProduct",
              gridDataField: "ProductCode",
              filterIndex: 1,
            },
            // Count
            {
              screenField: "Count",
              width: ColumnWidth.Quantity2Points.width,
              minWidth: ColumnWidth.Quantity2Points.minWidth,
              filterIndex: 6,
              // type: "Integer",
              intOperators: true,
            },
            // Yield
            {
              screenField: "Yield",
              width: ColumnWidth.Quantity2Points.width,
              minWidth: ColumnWidth.Quantity2Points.minWidth,
              filterIndex: 2,
              // type: "Integer",
              intOperators: true,
            },
            // Serious Defects
            {
              screenField: "SeriousDefects",
              width: ColumnWidth.Quantity2Points.width,
              minWidth: ColumnWidth.Quantity2Points.minWidth,
              filterIndex: 3,
              // type: "Integer",
              intOperators: true,
            },
            // Stain
            {
              screenField: "Stain",
              width: ColumnWidth.Quantity2Points.width,
              minWidth: ColumnWidth.Quantity2Points.minWidth,
              filterIndex: 4,
              // type: "Integer",
              intOperators: true,
            },
            // Moisture
            {
              screenField: "Moisture",
              width: ColumnWidth.Quantity2Points.width,
              minWidth: ColumnWidth.Quantity2Points.minWidth,
              filterIndex: 5,
              // type: "Integer",
              intOperators: true,
            },
            // Full Lot
            {
              screenField: "FullLot",
              gridDataField: "FullLot",
              cellTemplate: "StatusYesNo",
              width: 60,
              minWidth: 60,
              allowSorting: false,
            },
            // Customer
            {
              screenField: "Customer",
              filterIndex: 10,
            },
            // Agent
            {
              screenField: "Agent",
              filterIndex: 11,
            },
            // Sub Region
            {
              screenField: "SubRegionCode",
              exportFields: undefined,
              filterIndex: 12,
            },
            // Offer Expiry
            {
              screenField: "Date",
              filterLabel: "Offer Expiry",
              gridDataField: "OfferExpiryDate",
              filterDataField: "OfferExpiryDate",
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
              filterIndex: 13,
            },
            // Sales Order
            {
              screenField: "SalesOrder",
              gridDataField: "SalesOrderCode",
              width: ColumnWidth.SalesOrderCode.width,
              minWidth: ColumnWidth.SalesOrderCode.minWidth,
              hyperlink: {
                url: `sales-order/review/__ID__`,
                dataField: "SalesOrderCode",
                target: "_blank",
              },
            },
            // Season Year
            {
              screenField: "AlmondcoIntakeSeason",
              filterDataField: "SeasonYear",
              gridDataField: "SeasonYear",
              label: "Season",
              filterLabel: "Season Year",
              filterIndex: 0,
              visible: false,
              filterDefaultValue: "CurrentFiscalYear",
              width: ColumnWidth.SeasonYear.width,
              minWidth: ColumnWidth.SeasonYear.minWidth,
            },
            // Sales Order Code (for filtering purpose, hidden in UI)
            {
              screenField: "Code",
              filterDataField: "SalesOrderCode",
              filterLabel: "Sales Order",
              showInColumnChooser: false,
              visible: false,
              filterIndex: 14,
              type: "Integer",
            },
            // Allocation Status
            {
              screenField: "InvoiceStatus",
              gridDataField: "AllocationStatus",
              filterDataField: "AllocationStatus",
              filterLabel: "Status",
              label: "Status",
              filterIndex: 7,
              cellTemplate: "Status",
              dataSourceConfig: {
                data: [
                  "Accepted",
                  "Assigned",
                  "Available",
                  "Incomplete",
                  "Invoiced",
                  "Offered",
                  "On Hold",
                  "Reserved",
                ],
              },
              filterDefaultValue: [
                "Available",
                "Reserved",
                "Offered",
                "On Hold",
              ],
              customBackGroundColor: (data) => {
                if (
                  data &&
                  data.AllocationStatus &&
                  data.AllocationStatus === "On Hold"
                )
                  return "#5b6b6ba1";
                else return null;
              },
            },
            // Full Lot (filter)
            {
              screenField: "FullLot",
              label: "Full Lot Filter",
              filterDataField: "FullLot",
              filterLabel: "Full Lot",
              filterIndex: 8,
              showInColumnChooser: false,
              dataSourceConfig: {
                data: [
                  { value: "Y", FullLot: "Yes" },
                  { value: "N", FullLot: "No" },
                ],
              },
              valueExpr: "value",
              displayExpr: "FullLot",
              visible: false,
              dataType: "boolean",
              multiSelect: false,
            },
            {
              screenField: "DeliveryNote",
              gridDataField: "DeliveryNote",
              dataField: "DeliveryNote",
              calculateSortValue: "DeliveryNote",
              visible: false,
            },
            // Email
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "LotNo",
            },
            // PDF
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
              menuItems: {
                makeDisabled: (data) => {
                  var items = [];
                  var x = { ...data };

                  x.column.PrintPreview.forEach((element) => {
                    let paramResult = {
                      screenField: "LotNo",
                      dataField: "LotNo",
                      parameterName: "LotNo",
                      filterRequired: false,
                    };
                    if (x.data.AllocationStatus === "Invoiced") {
                      paramResult = {
                        screenField: "DeliveryNote",
                        dataField: "DeliveryNote",
                        parameterName: "DeliveryNote",
                        filterRequired: false,
                      };
                    }
                    items.push({
                      ReportDisplayName: "C of A",
                      ScreenLayoutApplicationFeatureCode:
                        element.ScreenLayoutApplicationFeatureCode,
                      Parameters: JSON.stringify({
                        parameters: [paramResult],
                      }),
                      disabled: false,
                    });
                  });

                  return items;
                },
              },
            },
            // Print
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "LotNo",
            },
            // Ellipsis Menu
            {
              screenField: "GridRecordEllipsisMenu",
              allowSearch: false,
              cssClass: "padding-7",
              ellipsisMenu: {
                itemAction: (data) => {
                  const AllocationStatus = data.data.AllocationStatus;
                  var items = [
                    {
                      menuText: "Reserve",
                      data: data,
                      visible:
                        AllocationStatus === "Available" ||
                        AllocationStatus === "Incomplete",
                      onClick: () => {
                        this.onClickReserveLot(data.data);
                      },
                    },
                    {
                      menuText: "Remove Reservation",
                      data: data,
                      visible: AllocationStatus === "Reserved",
                      onClick: () => {
                        this.RemoveReservation(data.data);
                      },
                    },
                    {
                      menuText: "Offer",
                      data: data,
                      visible:
                        AllocationStatus === "Available" ||
                        AllocationStatus === "Incomplete" ||
                        AllocationStatus === "Reserved",
                      onClick: () => {
                        this.onClickOfferLot(data.data);
                      },
                    },
                    {
                      menuText: "Accept Offer",
                      data: data,
                      visible: AllocationStatus === "Offered",
                      onClick: () => {
                        this.AcceptOffer(data.data);
                      },
                    },
                    {
                      menuText: "Remove Offer",
                      data: data,
                      visible:
                        AllocationStatus === "Offered" ||
                        AllocationStatus === "Accepted",
                      onClick: () => {
                        this.RemoveOffer(data.data);
                      },
                    },
                    {
                      menuText: "Place on Hold",
                      data: data,
                      visible:
                        AllocationStatus === "Available" ||
                        AllocationStatus === "Incomplete",
                      onClick: () => {
                        this.PlaceOnHold(data.data);
                      },
                    },
                    {
                      menuText: "Remove Hold",
                      data: data,
                      visible: AllocationStatus === "On Hold",
                      onClick: () => {
                        this.RemoveHold(data.data);
                      },
                    },
                    {
                      menuText: "History",
                      data: data,
                      visible: true,
                      onClick: () => {
                        this.openHistory(data.data);
                      },
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              // makeDisabled: () => {
              //   return true;
              // },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack() {},
    openHistory(data) {
      this.selectedLotNo = data.LotNo;
      this.historyPopupVisible = true;
    },
    onReserveLotPopupHide() {
      this.ReserveLotPopupConfig.isPopupShow = false;
      this.dataModel = undefined;
    },
    onOfferLotPopupHide() {
      this.OfferLotPopupConfig.isPopupShow = false;
      this.dataModel = undefined;
    },
    onClickReserveLot(data) {
      this.ReserveLotPopupConfig = {
        ...this.ReserveLotPopupConfig,
        title: `Reserve Lot`,
        secondaryTitle: `${data.LotNo} - ${data.ProductCode} - Branch : ${data.BranchCode}`,
        isPopupShow: true,
        formMode: "edit",
        dataModel: data,
      };
    },
    onClickOfferLot(data) {
      this.OfferLotPopupConfig = {
        ...this.OfferLotPopupConfig,
        title: `Offer Lot`,
        secondaryTitle: `${data.LotNo} - ${data.ProductCode} - Branch : ${data.BranchCode}`,
        isPopupShow: true,
        formMode: "edit",
        dataModel: data,
      };
    },
    postProcessGridData(data) {
      return data.map((item) => {
        return {
          ...item,
          BranchDescription: item.BranchName,
          ProductDescription1: item.ProductDescription,
        };
      });
    },
    onRowPreparedCallBack(e) {
      if (e.rowType === "data") {
        if (e.data.AllocationStatus === "Accepted") {
          e.rowElement.style.backgroundColor = "rgba(255, 165, 0, 0.1)";
        } else if (e.data.AllocationStatus === "Assigned") {
          e.rowElement.style.backgroundColor = "rgba(170, 98, 227, 0.1)";
        } else if (e.data.AllocationStatus === "Available") {
          e.rowElement.style.backgroundColor = "rgba(98, 210, 111, 0.1)";
        } else if (e.data.AllocationStatus === "Incomplete") {
          e.rowElement.style.backgroundColor = "rgba(232, 56, 79, 0.1)";
        } else if (e.data.AllocationStatus === "Invoiced") {
          e.rowElement.style.backgroundColor = "rgba(65, 134, 224, 0.1)"; // rgb(65, 134, 224)
        } else if (e.data.AllocationStatus === "Offered") {
          e.rowElement.style.backgroundColor = "rgba(56, 176, 232, 0.1)";
        } else if (e.data.AllocationStatus === "On Hold") {
          e.rowElement.style.backgroundColor = "rgba(91, 107, 107, 0.1)";
        } else if (e.data.AllocationStatus === "Reserved") {
          e.rowElement.style.backgroundColor = "rgba(128, 0, 128, 0.1)";
        }
      }
    },
    async executeAllocationAction(data, serviceMethod, successMsg, errorTitle) {
      this.setLoading = true;
      const payload = {
        LotNo: data.LotNo,
        CustomerCode: data.CustomerCode,
        AgentCode: data.AgentCode,
        SubRegionCode: data.SubRegionCode,
      };

      try {
        const response = await serviceMethod(payload);
        if (response) {
          this.onReserveLotPopupHide();

          this.$notify(successMsg, "success");
          this.$nextTick(() => {
            this.$refs["almondco-inshell-allocation-list"].$refs[
              "transactionListGrid"
            ].gridRepaint();
          });
        }
      } catch (error) {
        this.setLoading = false;
        this.$store.dispatch("ui/setServerError", {
          error: error,
          title: errorTitle,
        });
      } finally {
        this.setLoading = false;
      }
    },
    PlaceOnHold(data) {
      this.executeAllocationAction(
        data,
        InshellService.PlaceOnHold.bind(InshellService),
        "Lot placed on hold successfully.",
        "Failed to Place on Hold",
      );
    },
    AcceptOffer(data) {
      this.executeAllocationAction(
        data,
        InshellService.AcceptOffer.bind(InshellService),
        "Lot offer accepted successfully.",
        "Failed to Accept Offer",
      );
    },
    RemoveReservation(data) {
      this.executeAllocationAction(
        data,
        InshellService.RemoveReservation.bind(InshellService),
        "Lot reservation removed successfully.",
        "Failed to Remove Reservation",
      );
    },
    RemoveOffer(data) {
      this.executeAllocationAction(
        data,
        InshellService.RemoveOffer.bind(InshellService),
        "Lot offer removed successfully.",
        "Failed to Remove Offer",
      );
    },
    RemoveHold(data) {
      this.executeAllocationAction(
        data,
        InshellService.RemoveHold.bind(InshellService),
        "Lot hold removed successfully.",
        "Failed to Remove Hold",
      );
    },
    ReserveLot(data) {
      this.executeAllocationAction(
        data,
        InshellService.ReserveLot.bind(InshellService),
        "Lot reserved successfully.",
        "Failed to Reserve Lot",
      );
    },
    async OfferLot(data) {
      this.setLoading = true;
      try {
        const response = await InshellService.OfferLot(data);
        if (response) {
          this.onOfferLotPopupHide();
          this.$notify("Lot offered successfully.", "success");
          this.$nextTick(() => {
            this.$refs["almondco-inshell-allocation-list"].$refs[
              "transactionListGrid"
            ].gridRepaint();
          });
        }
      } catch (error) {
        this.setLoading = false;
        this.$store.dispatch("ui/setServerError", {
          error: error,
          title: "Failed to Offer Lot",
        });
      } finally {
        this.setLoading = false;
      }
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
